import Link from "next/link"
import { useRouter } from "next/router"

type Props = {
  title: string
  path?: string
  hasBackButton?: boolean
}

/** パブリックなページのヘッダ */
const PageHeader: React.FC<Props> = ({ title, path, hasBackButton = true }) => {
  const router = useRouter()

  return (
    <header className="p-page-header">
      <div className="p-page-header-inner">
        <h1 className="p-page-header-title">{title}</h1>
        {path ? (
          <Link href={path}>
            <a className="p-page-header-icon -back">
              <span className="sr-only">戻る</span>
            </a>
          </Link>
        ) : hasBackButton ? (
          <a
            className="p-page-header-icon -back"
            href="#back"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault()
              router.back()
            }}
          >
            <span className="sr-only">戻る</span>
          </a>
        ) : null}
      </div>
    </header>
  )
}

export default PageHeader
